export default __webpack_public_path__ + "static/media/star.ac14d309.svg";